import type { MeResponse } from "@klantpunt/shared";
import { IconAlert, IconInfo } from "./icons";

const DAY = 86_400_000;
const fmt = (iso: string) => new Date(iso).toLocaleDateString("nl-NL", { day: "numeric", month: "long" });

/**
 * Abonnement in beeld: alleen lezen (iedereen), of proefperiode die binnen 7 dagen afloopt
 * (eigenaar en beheerder).
 */
export function SubscriptionBanner({ me }: { me: MeResponse }) {
  const sub = me.org?.subscription;
  if (!sub) return null;
  if (sub.readOnly) {
    return (
      <div className="subbanner ro" role="status">
        <IconAlert size={18} aria-hidden="true" />
        <span>
          <strong>Alleen lezen.</strong>{" "}
          {sub.status === "trial" ? "De proefperiode is afgelopen" : "Het abonnement is niet actief"}: bekijken en
          exporteren kan nog, nieuwe bevindingen vastleggen niet. Neem contact op met Klantpunt.
        </span>
      </div>
    );
  }
  const manager = me.role === "owner" || me.role === "beheerder";
  if (manager && sub.status === "trial" && sub.trialEndsAt) {
    const left = new Date(sub.trialEndsAt).getTime() - Date.now();
    if (left < 7 * DAY)
      return (
        <div className="subbanner trial" role="status">
          <IconInfo size={18} aria-hidden="true" />
          <span>De proefperiode loopt tot en met {fmt(sub.trialEndsAt)}.</span>
        </div>
      );
  }
  return null;
}
